import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem("onex_cart")) || []; } catch { return []; } });
  const [open, setOpen] = useState(false);
  useEffect(() => { localStorage.setItem("onex_cart", JSON.stringify(items)); }, [items]);
  const key = (i) => `${i.product_id}:${i.variant_id || ""}`;
  const add = (p, variant, qty = 1) => {
    const item = { product_id: p.product_id, variant_id: variant?.variant_id || null, slug: p.slug, name: p.name,
      variant_name: variant?.name || null, image: p.images?.[0]?.path, price: variant?.price || p.price, qty };
    setItems((cur) => {
      const ex = cur.find((c) => key(c) === key(item));
      return ex ? cur.map((c) => (key(c) === key(item) ? { ...c, qty: Math.min(10, c.qty + qty) } : c)) : [...cur, item];
    });
    setOpen(true);
  };
  const setQty = (k, qty) => setItems((cur) => cur.map((c) => (key(c) === k ? { ...c, qty: Math.max(1, Math.min(10, qty)) } : c)));
  const remove = (k) => setItems((cur) => cur.filter((c) => key(c) !== k));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, count, subtotal, open, setOpen, key }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
